import React, { Component } from 'react';
import View from 'components/View';
import SpecificCodeForm from './SpecificCodeForm';
import RegistrationForm from './RegistrationForm';
import RegistrationCompletedForm from './RegistrationCompletedForm';

export class RegisterPage extends Component {
  state = {
    step: 1,
    code: '',
    name: '',
    surname: '',
    bornAt: '',
    email: '',
    phoneNumber: '',
    username: '',
    password: '',
    verifyPassword: '',
    address: '',
    infApprove: false,
    infMail: false,
    gender: 'MALE'
  };

  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1
    });
  };

  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1
    });
  };

  handleChange = input => e => {
    if (input === 'personalDataApproval' || input === 'actionsSendingApproval') {
      this.setState({ [input]: e.target.checked });
    } else {
      this.setState({ [input]: e.target.value });
    }
  };

  handleValueChange = (field, value) => {
    this.setState({ [field]: value });
  };

  render() {
    const { step } = this.state;
    const {
      code,
      name,
      surname,
      bornAt,
      email,
      phoneNumber,
      username,
      password,
      verifyPassword,
      address,
      infApprove,
      infMail,
      gender
    } = this.state;
    const values = {
      code,
      name,
      surname,
      bornAt,
      email,
      phoneNumber,
      username,
      password,
      verifyPassword,
      address,
      infApprove,
      infMail,
      gender
    };

    switch (step) {
      case 1:
        return (
          <SpecificCodeForm
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            handleValueChange={this.handleValueChange}
            values={values}
          />
        );
      case 2:
        return (
          <RegistrationForm
            prevStep={this.prevStep}
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            handleValueChange={this.handleValueChange}
            values={values}
          />
        );
      case 3:
        return <RegistrationCompletedForm prevStep={this.prevStep} />;
      default:
        return <View />;
    }
  }
}

export default RegisterPage;
